import { useMutation } from '@tanstack/react-query';
import { request } from '../services/request';

export const useContactPhotoRequestMutationQuery = () =>
    useMutation<any, Error, any>(async (data: { body: any; type: 'POST' | 'PUT',isPrivate:true | false  }) => {
        const jsonResponse = await request({
            data: data.body,
            method: data.type,
            isPrivate:data.isPrivate,
            endpoint:'contactphotorequest',
        });

        if (!jsonResponse.success) {
            throw new Error(jsonResponse.data.Message || 'Something went wrong');
        }

        return jsonResponse;
    });
